import { useState } from "react";

import { makePostApiCall, makePutApiCall } from "../../../shared/makeApiCall";
import LocationDetailsForm from "../../../components/forms/setup/locations/LocationDetailsForm";
import { BannerNotificationType } from "../../../components/SimpleNotification";
import DeleteConfirmationForm from "../../../components/forms/DeleteConfirmationForm";
import { updateObjectInArray } from "../../../shared/utility";

export function LocationsViewModel(logout) {
  const [loading, setLoading] = useState(false);
  const [locations, setLocations] = useState({
    data: [],
  });
  const [showSimpleNotification, setShowSimpleNotification] = useState({
    show: false,
    message: null,
    title: null,
    type: BannerNotificationType.Success,
  });
  const [slideOver, setSlideOver] = useState({
    childComponent: null,
    open: false,
  });
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });

  const getLocations = async function (search, page) {
    setLoading(true);

    let callResult = await makePostApiCall(
      `locations?page=${page}&search=${search}`
    );
    setLoading(false);
    if (callResult.success) {
      setLocations(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const createLocation = async function (values) {
    const payload = { ...values };
    let callResult = await makePostApiCall("locations/create", payload);

    if (callResult.success) {
      setShowSimpleNotification({
        show: true,
        title: "Location added",
        type: BannerNotificationType.Success,
      });
      setSlideOver({
        childComponent: null,
        open: false,
      });
      setTimeout(function () {
        getLocations("", 1);
      }, 1000);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const updateLocation = async function (values, index) {
    let callResult = await makePutApiCall(`locations/${values.id}`, values);

    if (callResult.success) {
      setShowSimpleNotification({
        show: true,
        title: "Location updated",
        type: BannerNotificationType.Success,
      });
      setSlideOver({
        childComponent: null,
        open: false,
      });

      const currentItems = [...locations.data];
      var payload = {
        index: index,
        item: callResult.data.item,
      };
      const newItems = updateObjectInArray(currentItems, payload);
      setLocations({ ...locations, data: newItems });
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const openAddLocationSlideOver = (isEdit, location, index) => {
    setSlideOver({
      childComponent: (
        <LocationDetailsForm
          location={location}
          isEdit={isEdit}
          setOpen={setSlideOver}
          actionCall={(payload) =>
            isEdit ? updateLocation(payload, index) : createLocation(payload)
          }
          title={isEdit ? `Update ${location.name}` : "Add new location"}
        />
      ),
      open: true,
    });
  };

  const deleteLocation = async function (id, index) {
    setLoading(true);

    let callResult = await makePostApiCall(`deleteLocation/${id}`);
    setLoading(false);
    if (callResult.success) {
      setEmptyModelOpen({
        open: false,
        childComponent: null,
      });

      const newItems = locations.data.filter((item) => item.id !== id);
      setLocations({ ...locations, data: newItems });

      setShowSimpleNotification({
        show: true,
        title: callResult.data.message,
        type: BannerNotificationType.Success,
      });
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const askDeleteLocation = function (location, index) {
    setEmptyModelOpen({
      childComponent: (
        <DeleteConfirmationForm
          buttonMessage="Delete"
          confirmAction={() => deleteLocation(location.id, index)}
          message={`Are you sure you want to delete  ${location.name}?`}
          setOpen={setEmptyModelOpen}
        />
      ),
      open: true,
    });
  };

  return {
    openAddLocationSlideOver,
    getLocations,
    loading,
    locations,
    setSlideOver,
    slideOver,
    setShowSimpleNotification,
    showSimpleNotification,
    setEmptyModelOpen,
    emptyModal,
    askDeleteLocation,
  };
}
